import { useEffect } from 'react';

const HomePage = () => {
  useEffect(() => {
    window.location.href = 'https://hippoprotocol.ai';
  }, []);

  return <section></section>;
};

export default HomePage;
